import { Provider } from '@angular/core';

import { MEDIA_BREAKPOINTS_PROVIDER, MediaBreakpointsProvider } from './media-breakpoints.provider';

export function provideMediaObserver(breakpoints: MediaBreakpointsProvider): Provider[] {
  return [
    {
      provide: MEDIA_BREAKPOINTS_PROVIDER,
      useValue: breakpoints,
    },
  ];
}
